"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));
var _intlI18n = require("@/i18n/intl-i18n");
var _CourseCard = _interopRequireDefault(require("../components/CourseCard.vue"));
var _NewsCard = _interopRequireDefault(require("../components/NewsCard.vue"));
var _CategoryFilter = _interopRequireDefault(require("../components/CategoryFilter.vue"));
var _international = require("@/api/international");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// ============================================================
// 国际专区首页逻辑
// ============================================================
var _default = exports.default = {
  name: 'IntlHome',
  mixins: [_intlI18n.intlMixin],
  components: {
    CourseCard: _CourseCard.default,
    NewsCard: _NewsCard.default,
    CategoryFilter: _CategoryFilter.default
  },
  data: function data() {
    return {
      featureNews: null,
      newsList: [],
      courseList: [],
      courseCats: [],
      activeCat: 'all'
    };
  },
  computed: {
    loadingText: function loadingText() {
      return this.$t('common.loading');
    },
    featureTitle: function featureTitle() {
      if (!this.featureNews) return this.$t('home.featureTitle');
      return this.featureNews.title;
    },
    featureDesc: function featureDesc() {
      if (!this.featureNews) return this.$t('home.featureDesc');
      return this.featureNews.summary;
    }
  },
  watch: {
    '$intlLang': function $intlLang() {
      this.loadFeatureNews();
      this.loadNewsTopList();
      this.loadCourseTopList();
    }
  },
  mounted: function mounted() {
    this.loadFeatureNews();
    this.loadNewsTopList();
    this.loadCourseCategories();
    this.loadCourseTopList();
  },
  methods: {
    // 加载重点动态
    loadFeatureNews: function () {
      var _loadFeatureNews = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _international.getFeatureNews)();
            case 1:
              res = _context.sent;
              if (res.data.code === 200) this.featureNews = res.data.data;
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('loadFeatureNews', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadFeatureNews() {
        return _loadFeatureNews.apply(this, arguments);
      }
      return loadFeatureNews;
    }(),
    // 加载动态列表 Top 3
    loadNewsTopList: function () {
      var _loadNewsTopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _international.getNewsTopList)({
                pageNum: 1,
                pageSize: 3
              });
            case 1:
              res = _context2.sent;
              if (res.data.code === 200) this.newsList = res.data.rows || [];
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('loadNewsTopList', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadNewsTopList() {
        return _loadNewsTopList.apply(this, arguments);
      }
      return loadNewsTopList;
    }(),
    // 加载课程分类
    loadCourseCategories: function () {
      var _loadCourseCategories = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _international.getCourseCategories)();
            case 1:
              res = _context3.sent;
              if (res.data.code === 200) this.courseCats = res.data.data || [];
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('loadCourseCategories', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadCourseCategories() {
        return _loadCourseCategories.apply(this, arguments);
      }
      return loadCourseCategories;
    }(),
    // 加载课程列表 Top 4
    loadCourseTopList: function () {
      var _loadCourseTopList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var params, res, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              params = {
                pageNum: 1,
                pageSize: 4
              };
              if (this.activeCat !== 'all') params.category = this.activeCat;
              _context4.next = 1;
              return (0, _international.getCourseTopList)(params);
            case 1:
              res = _context4.sent;
              if (res.data.code === 200) this.courseList = res.data.rows || [];
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              console.error('loadCourseTopList', _t4);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function loadCourseTopList() {
        return _loadCourseTopList.apply(this, arguments);
      }
      return loadCourseTopList;
    }(),
    // 分类切换 — 重新加载课程
    onCatChange: function onCatChange(cat) {
      this.activeCat = cat;
      this.loadCourseTopList();
    },
    // 跳转动态详情
    goNewsDetail: function goNewsDetail(news) {
      this.$router.push({
        path: '/international/newsDetail',
        query: {
          id: news.id
        }
      });
    },
    // 跳转课程详情
    goCourseDetail: function goCourseDetail(course) {
      this.$router.push({
        path: '/international/courseDetail',
        query: {
          id: course.id
        }
      });
    }
  }
};